import React from 'react';
import { resolveEmoji, emojiAssetPath } from 'functions/chatEmoji';

export default function LadderEmoji({ emoji, size = 21, tooltip = true, skin = 1 }) {
	const resolved = resolveEmoji(emoji, skin);
	if (!resolved) return typeof emoji === 'string' ? emoji : null;
	return <img className='ladder_emoji' src={emojiAssetPath(resolved.native)} alt={resolved.native}
		title={tooltip ? resolved.id : undefined} draggable={false} width={size} height={size}
		style={{ width: size, height: size, verticalAlign: '-0.2em', display: 'inline-block' }} />;
}
